import { MinutesToMilliseconds } from './HelperTime'

export const RequestStaleTime = {
    authentication: Infinity,
    default: MinutesToMilliseconds(10),
    long: MinutesToMilliseconds(60),
    metadata: MinutesToMilliseconds(180),
    configuration: Infinity,
    none: 0,
}

export const RequestGcTime = {
    authentication: Infinity,
    default: MinutesToMilliseconds(10),
    long: MinutesToMilliseconds(60),
    metadata: MinutesToMilliseconds(360),
    configuration: Infinity,
    none: 0,
}
